import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {
    RegisteredFormField,
    SEARCH_FORM_EXTENDED_CONTROLS_MODE,
    SearchFormExtendedService
} from "../search-form-extended.service";
import {Subscription} from "rxjs";
import {FUIFormContext, FUIPillFormContext} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../../analytics/analytic-event";

/**
 * Search fields that are optionally added by the user. Individual fields should be added as wbo-search-form-field
 * components. The extendedSearchInput directive should be added to these fields to add them to the "More" drop down
 * list.
 */
@Component({
    selector: "wbo-search-form-extended-fields",
    templateUrl: "./search-form-extended-fields.component.html",
    styleUrls: ["./search-form-extended-fields.component.scss"],
    providers: [{provide: SEARCH_FORM_EXTENDED_CONTROLS_MODE, useValue: true},
        {provide: FUIFormContext, useClass: FUIPillFormContext}]
})
export class SearchFormExtendedFieldsComponent implements OnDestroy, OnInit {

    /**
     * List of all active form fields
     * @type {Array}
     */
    activeFormFields: Array<RegisteredFormField> = [];

    /**
     * List of selected form fields keys for the search
     * @type {Array}
     * @private
     */
    private _selectedFormFields: Array<string> = new Array<string>();

    private subscriptions: Subscription = new Subscription();

    constructor(public searchFormExtendedService: SearchFormExtendedService, private analyticsService: AnalyticsService,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this._selectedFormFields = this.searchFormExtendedService.selectedFormFields;

        this.subscriptions.add(this.searchFormExtendedService.$selectedFormFields.subscribe((value) => {
            this._selectedFormFields = value;
            this.buildActiveFormFields();
        }));

        this.subscriptions.add(this.searchFormExtendedService.requestFormFieldRemoved.subscribe(field => {
            this.removeFormField(field);
        }));

        this.subscriptions.add(this.searchFormExtendedService.$registeredTemplate.subscribe(() => {
            this.buildActiveFormFields();
        }));
    }

    buildActiveFormFields(): void {
        // remove selected search fields
        this.activeFormFields.forEach(fieldSelected => {
            if (!this._selectedFormFields.find(fieldNameSelected => fieldNameSelected === fieldSelected.field)) {
                this.searchFormExtendedService.notifyFormFieldRemoved(fieldSelected.field);
            }
        });
        //
        const wasActive = this.activeFormFields;
        this.activeFormFields = [];
        this._selectedFormFields.forEach(fieldSelected => {
            const extendedSearch: RegisteredFormField = this.searchFormExtendedService.registeredFormFields.find(
                fieldSearch => fieldSelected === fieldSearch.field);
            if (extendedSearch) {
                this.activeFormFields.push(extendedSearch);
                if (wasActive.indexOf(extendedSearch) === -1) {
                    this.analyticsService.trackEvent(AnalyticEvent.SEARCH_ADD_PILL, extendedSearch.field);
                }
            }
        });

        this.changeDetectorRef.detectChanges();
    }

    /**
     * Remove a form field from the search
     * @param field
     */
    removeFormField(field: string): void {
        this.activeFormFields.forEach((formField: RegisteredFormField) => {
            if (formField.field === field) {
                this.searchFormExtendedService.notifyFormFieldRemoved(field);

                this._selectedFormFields.splice(this._selectedFormFields.indexOf(field), 1);

                // give time for the components before deleting them to avoid view destroyed
                setTimeout(() => this.searchFormExtendedService.selectedFormFields = this._selectedFormFields);
            }
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
